import StarBorderIcon from '@mui/icons-material/StarBorder';
import { ImageList, ImageListItem, Table, TableBody, TableCell, TableContainer, TableRow, Paper, useMediaQuery, useTheme } from '@mui/material';

import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVk } from '@fortawesome/free-brands-svg-icons';

import { Box, Typography, IconButton, Link, Stack, LinearProgress, Button, TextField, Select, MenuItem, FormControl, InputLabel, Checkbox, FormControlLabel} from "@mui/material";
import "../detailsProgram/DetailsProgram.css"

import { React, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, Link as RouterLink } from 'react-router-dom';
import { ImageSlider } from '../imageSlider/ImageSlider';
import { baseUrlApi } from '../constants';
import { ReviewsSlider } from '../reviewSlider/ReviewSlider.jsx';

import { PopupConsultation } from "../popupConsultation/PopupConsultation.jsx"

import axiosBase from '../../axios';

// Функция для преобразования URL в гиперссылки (с защитой существующих тегов)
const convertUrlsToLinks = (text) => {
    if (!text) return '';
    
    // Защищаем уже существующие теги <a> от обработки
    const preservedTags = [];
    let processedText = text.replace(/<a\s+[^>]*>.*?<\/a>/gi, (match) => {
        preservedTags.push(match);
        return `__PRESERVE_TAG_${preservedTags.length - 1}__`;
    });
    
    // Регулярка для ссылок: http://, https://, и домены без протокола
    const urlRegex = /(?:https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)/gi;
    
    processedText = processedText.replace(urlRegex, (url) => {
        // Проверяем, не является ли URL частью защищенного тега
        if (url.includes('__PRESERVE_TAG_')) return url;
        
        let cleanUrl = url;
        let trailingChar = '';
        
        // Убираем знаки препинания в конце
        if (cleanUrl.endsWith('.') || cleanUrl.endsWith(',') || cleanUrl.endsWith(';') || cleanUrl.endsWith('!') || cleanUrl.endsWith('?')) {
            trailingChar = cleanUrl.slice(-1);
            cleanUrl = cleanUrl.slice(0, -1);
        }
        
        // Добавляем http:// если нет протокола
        let fullUrl = cleanUrl;
        if (!fullUrl.startsWith('http://') && !fullUrl.startsWith('https://')) {
            fullUrl = 'http://' + fullUrl;
        }
        
        // Формируем отображаемый текст (без http:// и www.)
        let displayText = cleanUrl;
        try {
            const urlObj = new URL(fullUrl);
            displayText = urlObj.hostname.replace(/^www\./, '');
            if (urlObj.pathname !== '/') {
                displayText += urlObj.pathname;
            }
        } catch (e) {
            displayText = cleanUrl;
        }
        
        return `<a href="${fullUrl}" target="_blank" rel="noopener noreferrer" style="color: #1976d2; text-decoration: underline;">${displayText}</a>${trailingChar}`;
    });
    
    // Возвращаем защищённые теги <a> обратно
    processedText = processedText.replace(/__PRESERVE_TAG_(\d+)__/g, (match, index) => {
        return preservedTags[parseInt(index)];
    });
    
    return processedText;
};

export function DetailsProgram() {
    const [dataProgram, setDataProgram] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const { programm_id } = useParams(); 
    const isEditingProgram = Boolean(programm_id);
    const [isAdmin, setIsAdmin] = useState(false);
    
    const today = new Date().toISOString().split("T")[0];
    const [reviews, setReviews] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [newReview, setNewReview] = useState({
        author: "",
        gender: "male",
        rating: 5,
        text: "",
        dateNewsFormat: today
    });
    const [useToday, setUseToday] = useState(true);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await axiosBase.post(
                `/program/${programm_id}/reviews`,
                newReview
            );
            setReviews((prev) => [...prev, res.data]);
            setNewReview({
                author: "",
                gender: "male",
                rating: 5,
                text: "",
                dateNewsFormat: today
            });
            setUseToday(true);
            setShowForm(false);
        } catch (err) {
            console.error("Ошибка при добавлении отзыва", err);
            alert("Не удалось сохранить отзыв");
        }
    };

    const dispatch = useDispatch();
    const { data } = useSelector((state) => state.auth);
    const PERCENT_LEFT_COLUMN = 40;
    const PERCENT_RIGHT_COLUMN = 60;

    const [isPopupVisible, setPopupVisible] = useState(false);
    const handleOpenPopup = () => {
        setPopupVisible(true);
    };
    const handleClosePopup = () => {
        setPopupVisible(false);
    };

    const isMobile = useMediaQuery('(max-width:600px)');
    
    useEffect(() => {
        axiosBase.get(`/programs/${programm_id}`)
            .then((programResponse) => {
                setDataProgram(programResponse.data);
                setIsLoading(false);
                console.log("С сервера пришла программа ", programResponse.data);
                return axiosBase.get(`/program/${programm_id}/reviews`);
            })
            .then((reviewsResponse) => {
                console.log("Данные отзывов!!!", reviewsResponse.data.reviews);
                setReviews(reviewsResponse.data.reviews);
            })
            .catch((err) => {
                console.error("Ошибка при загрузке:", err);
                alert("Ошибка загрузки данных");
            });
    }, [programm_id]); 

    useEffect(() => {
        if (data !== undefined && data !== null) {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }
    }, [data]);
    
    let heightGalery = 1300;
    if(dataProgram && dataProgram.arrLinkImg){
        const lengthArrLinkImg = dataProgram.arrLinkImg.length;
        if(lengthArrLinkImg > 10) heightGalery = 2800
        else if(lengthArrLinkImg > 8) heightGalery = 2000
        else if(lengthArrLinkImg > 6) heightGalery = 1600
        else if(lengthArrLinkImg > 4) heightGalery = 1200
        else if(lengthArrLinkImg > 2) heightGalery = 800
        else if(lengthArrLinkImg > 0) heightGalery = 400
    }
    
    const handleDeleteCardReview = async (id, programId) => {
        try {
            const res = await axiosBase.delete(`/program/${programId}/reviews/${id}`);
            if (res.data.success) {
                setReviews((prev) => prev.filter((r) => r._id !== id));
            } else {
                alert("Ошибка при удалении отзыва");
            }
        } catch (err) {
            console.error("Ошибка при удалении отзыва:", err);
            alert("Не удалось удалить отзыв");
        }
    };
    
    const arrFavoriteProgramsId = useSelector(state => state.favoritePrograms.arrIdFavoritePrograms);
    const isFavoriteCardDefault = (arrFavoriteProgramsId.includes(dataProgram._id));
    
    return(
        <>
            {isLoading ? (
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    width: '100%',
                }}>
                    <Stack sx={{ width: '70%', color: 'grey.500' }} spacing={2}>
                        <LinearProgress />
                    </Stack>
                </Box>
            ) : (
                <>
                    {isPopupVisible && <PopupConsultation isOpenPopupClick={ true } onClose={ handleClosePopup }/>}
                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'column', lg: 'row' }}}>
                        <Box 
                            ml='auto' 
                            mr='auto'
                            sx={{ pt: 0, width: isMobile ? "95%" : "85%", overflow: 'auto'}}
                        >
                            <Box>
                                {(isAdmin) && (
                                    <Box>
                                        <Button variant="outlined" sx={{marginRight: "20px"}}>
                                            <a href={`/program/${programm_id}/edit`} style={{textDecoration: "none"}}>
                                                Редактировать программу
                                            </a>
                                        </Button>
                                        <>
                                            {!showForm ? (
                                                <Button variant="contained" color="primary" onClick={() => setShowForm(true)}>
                                                    Добавить отзыв
                                                </Button>
                                            ) : (
                                                <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                                                    <TextField
                                                        label="Автор"
                                                        value={newReview.author}
                                                        onChange={(e) => setNewReview({ ...newReview, author: e.target.value })}
                                                        required
                                                    />
                                                    <FormControl fullWidth>
                                                        <InputLabel>Пол</InputLabel>
                                                        <Select value={newReview.gender} label="Пол" onChange={(e) => setNewReview({ ...newReview, gender: e.target.value })}>
                                                            <MenuItem value="male">Мужской</MenuItem>
                                                            <MenuItem value="female">Женский</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                    <TextField
                                                        type="number"
                                                        label="Рейтинг"
                                                        inputProps={{ min: 1, max: 5 }}
                                                        value={newReview.rating}
                                                        onChange={(e) => setNewReview({ ...newReview, rating: Number(e.target.value) })}
                                                        required
                                                    />
                                                    <TextField
                                                        label="Текст отзыва"
                                                        multiline
                                                        rows={4}
                                                        value={newReview.text}
                                                        onChange={(e) => setNewReview({ ...newReview, text: e.target.value })}
                                                        required
                                                    />
                                                    <FormControlLabel
                                                        control={<Checkbox checked={useToday} onChange={(e) => {
                                                            setUseToday(e.target.checked);
                                                            setNewReview({ ...newReview, dateNewsFormat: e.target.checked ? today : "" });
                                                        }} />}
                                                        label="Сегодня"
                                                    />
                                                    <TextField
                                                        type="date"
                                                        label="Дата"
                                                        InputLabelProps={{ shrink: true }}
                                                        value={newReview.dateNewsFormat}
                                                        onChange={(e) => setNewReview({ ...newReview, dateNewsFormat: e.target.value })}
                                                        disabled={useToday}
                                                        required
                                                    />
                                                    <Box sx={{ display: "flex", gap: 2 }}>
                                                        <Button type="submit" variant="contained" color="primary">Сохранить</Button>
                                                        <Button type="button" variant="outlined" color="error" onClick={() => setShowForm(false)}>Отмена</Button>
                                                    </Box>
                                                </Box>
                                            )}
                                        </>
                                    </Box>
                                )}
                                
                                <Box sx={{ display: 'flex'}}>
                                    <RouterLink to={'/learn'}>
                                        <IconButton sx={{ mb: 2, mr: 0 }}>
                                            <ArrowBackIcon />
                                        </IconButton>
                                    </RouterLink>
                                    <Typography ml='0px' color="#000000" variant={isMobile ? "h5" : "h4"} gutterBottom sx={{ pt: 0 }}>
                                        {dataProgram.titleProgram}
                                    </Typography>
                                    <IconButton aria-label="add" sx={{ mb: 2, mr: 3 }}>
                                        {isFavoriteCardDefault ? <ThumbUpIcon /> : <ThumbUpOffAltIcon />}
                                    </IconButton>
                                </Box>
                                
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'column', lg: 'row' },
                                }}>
                                    {dataProgram.arrLinkImg.length > 0 ? (
                                        <>
                                            <Typography
                                                component="div"
                                                ml='0px'
                                                sx={{
                                                    pt: 1,
                                                    pl: 2,
                                                    width: { xs: '95%', md: '95%', lg: '50%' },
                                                    fontSize: '18px',
                                                    textAlign: 'justify',
                                                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                                    lineHeight: 1.5,
                                                    '& p': { margin: '0 0 10px 0' },
                                                    '& p:last-child': { marginBottom: 0 }
                                                }}
                                                dangerouslySetInnerHTML={{ __html: convertUrlsToLinks(dataProgram.textProgram || '') }}
                                            />
                                            <Box sx={{ width: { xs: '100%', md: '100%', lg: '50%' } }}>
                                                <ImageSlider arr_img_url={dataProgram.arrLinkImg} />
                                            </Box>
                                        </>
                                    ) : (
                                        <Typography
                                            component="div"
                                            ml='0px'
                                            sx={{
                                                pt: 1,
                                                pl: 2,
                                                width: '100%',
                                                fontSize: '18px',
                                                textAlign: 'justify',
                                                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                                lineHeight: 1.5,
                                                '& p': { margin: '0 0 10px 0' },
                                                '& p:last-child': { marginBottom: 0 }
                                            }}
                                            dangerouslySetInnerHTML={{ __html: convertUrlsToLinks(dataProgram.textProgram || '') }}
                                        />
                                    )}
                                </Box>

                                <TableContainer component={Paper} style={{ boxShadow: 'none', border: 'none', width: '100%'}}>
                                    <Table style={{ borderCollapse: 'collapse', backgroundColor: 'transparent' }}>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>Финансирование:</TableCell>
                                                {dataProgram.isBudgetProgramm ? 
                                                    (<TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>бюджетная программа</TableCell>) :
                                                    (<TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>платная услуга</TableCell>)}
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>Возраст:</TableCell>
                                                {dataProgram.ageRangeProgram[0] === dataProgram.ageRangeProgram[1] ? 
                                                    (<TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>{`${dataProgram.ageRangeProgram[0]} лет`}</TableCell>) :
                                                    (<TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>{`${dataProgram.ageRangeProgram[0]}-${dataProgram.ageRangeProgram[1]} лет`}</TableCell>)}
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>Срок обучения:</TableCell>
                                                <TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>{dataProgram.trainingPeriod}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>Количество занятий в неделю:</TableCell>
                                                <TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>{dataProgram.numLessons}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>Количество обучающихся в группе:</TableCell>
                                                {dataProgram.numberStudents[0] === dataProgram.numberStudents[1] ? 
                                                    (<TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>{dataProgram.numberStudents[0]}</TableCell>) :
                                                    (<TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>{`${dataProgram.numberStudents[0]}-${dataProgram.numberStudents[1]}`}</TableCell>)}
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>Специализация:</TableCell>
                                                <TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>{dataProgram.typesProgram.join(', ')}</TableCell>
                                            </TableRow>
                                            
                                            {dataProgram.fileUrl && (
                                                <TableRow>
                                                    <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>Скачать программу:</TableCell>
                                                    <TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>
                                                        <Link href={`${baseUrlApi}${dataProgram.fileUrl}`} target="_blank" rel="noopener noreferrer">текст программы</Link>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                            
                                            <TableRow>
                                                <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', verticalAlign: 'top', fontSize: '18px' }}>Подойдет ли программа ребенку?</TableCell>
                                                <TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>
                                                    <Link href="https://testometrika.com/business/test-to-determine-career/" target="_blank" rel="noopener noreferrer">Пройти тест</Link> 
                                                    {' '}Климова на профориентацию или{' '}
                                                    <Button onClick={handleOpenPopup}>записаться</Button>
                                                    {' '}на проф консультацию к специалистам нашего центра
                                                </TableCell>
                                            </TableRow>

                                            {dataProgram.linkVideo && (
                                                isMobile ? (
                                                    <TableRow>
                                                        <TableCell colSpan={2} style={{ borderBottom: 'none', padding: 0 }}>
                                                            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                                                                <iframe title="YouTube Video" width="100%" height="100%" src={dataProgram.linkVideo} frameBorder="0" allowFullScreen style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} />
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    <TableRow>
                                                        <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', fontSize: '18px', verticalAlign: 'top' }}>{dataProgram.commentVideo}</TableCell>
                                                        <TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>
                                                            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                                                                <iframe title="YouTube Video" width="100%" height="100%" src={dataProgram.linkVideo} frameBorder="0" allowFullScreen style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} />
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            )}

                                            {dataProgram.linkPosts.length !== 0 && (
                                                <TableRow>
                                                    <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>Новостные посты, освещающие деятельность, достижения обучающихся:</TableCell>
                                                    <TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>
                                                        {dataProgram.linkPosts.map(element => (
                                                            <Box key={element.comment}>
                                                                <Link href={element.link} target="_blank" rel="noopener noreferrer">{element.comment}</Link>
                                                            </Box>
                                                        ))}
                                                    </TableCell>
                                                </TableRow>
                                            )}

                                            {dataProgram.linkGroup && (
                                                <TableRow>
                                                    <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', verticalAlign: 'top', fontSize: '18px' }}>О том, чем занимаются дети рассказываем в социальных сетях. Следите за нашими новостями!</TableCell>
                                                    <TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>
                                                        <IconButton aria-label="vk">
                                                            <a href={dataProgram.linkGroup} target="_blank">
                                                                <FontAwesomeIcon icon={faVk} style={{ color: "#0077ff", fontSize: "40px", verticalAlign: 'middle' }} />
                                                            </a>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                            
                                            {dataProgram.instructors.length !== 0 && (
                                                <TableRow>
                                                    <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>Педагоги:</TableCell>
                                                    <TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>
                                                        {dataProgram.instructors.map((element, index) => (
                                                            <Box key={element.name || index}>
                                                                {element.link && element.link.trim() !== '' ? (
                                                                    <Link href={element.link} target="_blank" rel="noopener noreferrer">{element.name}</Link>
                                                                ) : (
                                                                    <span>{element.name}</span>
                                                                )}
                                                            </Box>
                                                        ))}
                                                    </TableCell>
                                                </TableRow>
                                            )}

                                            {dataProgram.commentProgram && (
                                                <TableRow>
                                                    <TableCell style={{ width: `${PERCENT_LEFT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>Комментарий:</TableCell>
                                                    <TableCell style={{ width: `${PERCENT_RIGHT_COLUMN}%`, borderBottom: 'none', fontSize: '18px' }}>
                                                        <Typography
                                                            component="div"
                                                            sx={{
                                                                fontSize: '18px',
                                                                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                                                lineHeight: 1.5
                                                            }}
                                                            dangerouslySetInnerHTML={{ __html: convertUrlsToLinks(dataProgram.commentProgram) }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                
                                <ReviewsSlider 
                                    reviews={reviews} 
                                    programm_id={programm_id}
                                    isAdmin={isAdmin} 
                                    onDelete={handleDeleteCardReview}
                                />
                                
                                {dataProgram.arrLinkImg.length > 0 && (
                                    <Box style={{ margin: "0 auto", maxWidth: 1200 }}>
                                        <Typography variant="h4" sx={{ textAlign: 'center', mt: 2, mb: 4, fontWeight: 'bold', color: 'black' }}>
                                            Галерея
                                        </Typography>
                                        <ImageList sx={{ maxWidth: isMobile ? '100%' : 1200, height: heightGalery }} cols={isMobile ? 1 : 2} rowHeight={164}>
                                            {dataProgram.arrLinkImg.map((item) => (
                                                <ImageListItem key={item}>
                                                    <img src={`${baseUrlApi}${item}`} loading="lazy" />
                                                </ImageListItem>
                                            ))}
                                        </ImageList>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </>
            )}
        </>
    )
}